import { render } from "./prospectNumbers.vue?vue&type=template&id=f6ed660c"
import script from "./prospectNumbers.vue?vue&type=script&lang=js"
export * from "./prospectNumbers.vue?vue&type=script&lang=js"

import "./prospectNumbers.vue?vue&type=style&index=0&id=f6ed660c&lang=css"

import exportComponent from "C:\\Users\\Luis\\Documents\\Anfisbena\\Projects\\crm\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__